//bao migrate skip
import template from "./column-layout.html";
import {ColumnLayoutComponent} from "./column-layout-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new ColumnLayoutComponent(params, componentInfo.element);
            return vm;
        }
    },
    template: template
};